// extracted by mini-css-extract-plugin
export default {"user_overlay":"User_user_overlay__gpRsd","user_error__message":"User_user_error__message__arKF5"};